import React from 'react';
import Modal from 'antd/lib/modal';
import styled from 'styled-components';
import { Flex } from '../components/Flex';

const NumberBullet = styled.ol`
  list-style: decimal;
`;

const ReferralTerms = ({ showTerms, onCancel }) => {
  return (
    <Modal
      visible={showTerms}
      footer={null}
      mask
      maskClosable
      onCancel={onCancel}
      title="Workstream Referral Terms and Conditions:"
    >
      <Flex column px={3}>
        <NumberBullet>
          <li>The exclusive Workstream referral program will be valid until 30 June 2021.</li>
          <li>All referrals must be made during the aforementioned validity period.</li>
          <li>For each successful referral, Workstream will send over a $200 Amazon Gift Card via email with a working gift code.</li>
          <li>A referral is considered successful when a newly referred client makes their first month of subscription payment with Workstream.</li>
          <li>This promotion cannot be combined with any other promotions, discounts, or offers. Administrators of multiple accounts may not refer themselves.</li>
          <li>The business has 180 days from the date of the referral to sign up and complete their first paid billing cycle with Workstream. The referral bonus will expire 180 days after the referred date.</li>
          <li>The business must be a new, first time client of Workstream.</li>
          <li>If a company has been referred to Workstream by multiple people, then Workstream will split the referral bonus across all the people that have made referrals.</li>
          <li>Whether a payout is due shall be a decision made in the sole discretion of Workstream. Workstream reserves the right to declare a referral ineligible for the promotion for any reasons. Questions should be addressed to referrals@workstream.is.</li>
        </NumberBullet>
        <br/>
        <p>This program is not affiliated with the employer of the job you have applied to. I have read the terms and conditions and agree to them.</p>
      </Flex>
    </Modal>
  )
}

export default ReferralTerms;
